import React, { useState } from 'react';
import { TextField, Grid2, Box, Container, Button } from '@mui/material';
import GooglePlace from '../google_api/GoogleLocation';
import rangeCalculator from '../../utils/rangeCalculatorAlgorithm';
import TuneIcon from '@mui/icons-material/Tune';
import FiltersPopup from './FiltersPopup';

const HomePageFilters = ({ onSearch }) => {
  const [placeLocation, setSelectedPlaceLocation] = useState(null);
  const [radius, setRadius] = useState(50000);
  const [isFiltersOpen, setFiltersOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});
  const isFilterButtonEnabled = placeLocation && radius > 0;
  const hasAppliedFilters = Object.keys(appliedFilters).length > 0;

  const handleOpenFilters = () => setFiltersOpen(true);
  const handleCloseFilters = () => setFiltersOpen(false);

  const handlePlaceSelected = (selectedPlaceLocation) => {
    setSelectedPlaceLocation({
      place_id: selectedPlaceLocation.place_id,
      place_description: selectedPlaceLocation.place_description,
      latitude: selectedPlaceLocation.latitude,
      longitude: selectedPlaceLocation.longitude,
    });
  };

  const handleRadiusChange = (e) => {
    const value = e.target.value;
    setRadius(value);
  };

  const calculateRange = () => {
    if (!placeLocation) {
      return null;
    }
    const latitude = placeLocation.latitude;
    const longitude = placeLocation.longitude;
    const radiusValue = Number(radius);
    const calculatedRange = rangeCalculator(latitude, longitude, radiusValue);

    if (calculatedRange) {
      const { minLatitude, maxLatitude, minLongitude, maxLongitude } = calculatedRange;
      return { minLatitude, maxLatitude, minLongitude, maxLongitude };
    }
    return null;
  };

  const handleSubmitFilters = (filters) => {
    setAppliedFilters(filters);
    handleCloseFilters();
    handleSearch(null, filters);
  };

  const handleResetFilters = () => {
    setAppliedFilters({});
  };

  const handleSearch = (e, filters = appliedFilters) => {
    if (e && e.preventDefault) e.preventDefault();
    const distanceRange = calculateRange();
    if (!distanceRange || !placeLocation) return;

    onSearch({
      min_latitude: distanceRange.minLatitude,
      max_latitude: distanceRange.maxLatitude,
      min_longitude: distanceRange.minLongitude,
      max_longitude: distanceRange.maxLongitude,
      place_description: placeLocation.place_description,
      ...filters,
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center', py: 2 }}>
      <Container maxWidth="lg">
        <Grid2 container spacing={2} alignItems="center">
          {/* Location Input */}
          <Grid2 item xs={12} sm={6}>
            <GooglePlace onPlaceSelected={handlePlaceSelected} />
          </Grid2>

          {/* Radius Input */}
          {/* <Grid2 item xs={12} sm={3}>
            <TextField
              id="radius"
              name="radius"
              label="Range (m)"
              type="number"
              onChange={handleRadiusChange}
              fullWidth
              value={radius}
              size="small" // Smaller input for mobile
            />
          </Grid2> */}

          {/* Filter Button */}
          <Grid2 item xs={6} sm={1.5}>
            <Button
              variant={hasAppliedFilters ? 'contained' : 'outlined'}
              color={hasAppliedFilters ? 'primary' : 'inherit'}
              startIcon={<TuneIcon />}
              onClick={handleOpenFilters}
              disabled={!isFilterButtonEnabled}
              fullWidth
              sx={{ height: { xs: '40px', sm: '48px' } }} // Responsive height
            />
          </Grid2>

          {/* Search Button */}
          <Grid2 item xs={6} sm={1.5}>
            <form onSubmit={handleSearch}>
              <Button
                type="submit"
                variant="contained"
                disabled={!placeLocation}
                fullWidth
                sx={{ height: { xs: '40px', sm: '48px' } }} // Responsive height
              >
                Search
              </Button>
            </form>
          </Grid2>
        </Grid2>
      </Container>

      {/* Filters Popup */}
      <FiltersPopup
        isFiltersOpen={isFiltersOpen}
        handleCloseFilters={handleCloseFilters}
        onSubmitFilters={handleSubmitFilters}
        onResetFilters={handleResetFilters}
      />
    </Box>
  );
};

export default HomePageFilters;